import { render, staticRenderFns } from "./TheSvgAssets.vue?vue&type=template&id=563cab50&"
import script from "./TheSvgAssets.vue?vue&type=script&lang=js&"
export * from "./TheSvgAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports